<mat-form-field class="w-100">
  <input type="text"
    [placeholder]="placeholder"
    matInput
    [formControl]="searchInput"
    #input
    required>
  <mat-error *ngIf="showRequiredError">
    {{ 'COMMON.VALIDATION.REQUIRED' | translate }}</mat-error>
</mat-form-field>